import { render, staticRenderFns } from "./RingSettings.vue?vue&type=template&id=596705ba&"
import script from "./RingSettings.vue?vue&type=script&lang=js&"
export * from "./RingSettings.vue?vue&type=script&lang=js&"
import style0 from "./RingSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2065084294/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('596705ba')) {
      api.createRecord('596705ba', component.options)
    } else {
      api.reload('596705ba', component.options)
    }
    module.hot.accept("./RingSettings.vue?vue&type=template&id=596705ba&", function () {
      api.rerender('596705ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RingSettings.vue"
export default component.exports